'use strict';

angular.module('upAttributes').service('CategoryAtributes', [
	'FilterType',
	'DisplayType',
	function (FilterType, DisplayType) {
		return function () {
			var attributes = {
				id: {
					title: 'default.id',
					field: 'id',
					type: FilterType.Number,
					displayType: DisplayType.Number,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				name: {
					title: 'default.name',
					field: 'name',
					type: FilterType.String,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				categoryType: {
					field: 'categoryType',
					type: FilterType.Number
				}
			};

			return {
				getAll: function () {
					return attributes;
				},
				attr: attributes,
				keys: {
					ID: 'id',
					NAME: 'name',
					CATEGORYTYPE: 'categoryType'
				}
			};
		};
	}
]);
